import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as c3 from 'c3';
import { MatDialog } from '@angular/material/dialog';
import { DaChartPopupComponent } from '../da-chart-popup/da-chart-popup.component';
import { log } from 'console';
import { FactorySummaryDetails, TrendsResponse } from '../../models/factory-summary';
import { DataAnalyticsService } from '../../services/data-analytics.service';
import { tick } from '@angular/core/testing';
import { format } from 'url';
import { CurrencyService } from 'src/app/shared/service/currency.service';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
@Component({
  selector: 'app-da-trends',
  templateUrl: './da-trends.component.html',
  styleUrls: ['./da-trends.component.scss']
})
export class DaTrendsComponent implements OnInit, AfterViewInit {

  @Input() factorySummary: FactorySummaryDetails;
  @Input() currentDate: string;
  @Input() currrentFilter: string;
  @Input() trendsData: TrendsResponse = {};
  @ViewChild('lineGraphDiv') lineGraphDiv: ElementRef;
  @ViewChild('barGraphDiv') barGraphDiv: ElementRef;

  public selectedChartType = 'cost'; // percentage
  public actualConsList;
  public zeroBasedList;
  public targetBasedList;
  public wastePercent;
  public targetWasteCost;
  public xAxisValuesCost;
  public xAxisValuesPercentage;
  public divisionNumber = 1;
  public signType = '';
  public currencyRate = 1;

  public barChart: any;
  public lineChart: any;
  public level: string;
  public lineId: string;
  public oneDate: any;
  public monthName: any;
  currentEndWeek: any;
  emitDataList: any;

  constructor(
    public dialog: MatDialog,
    private dataAnalyticService: DataAnalyticsService,
    private currencyService: CurrencyService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    // if (this.barChart && this.barChart.resize) {
    //   this.barChart.resize({
    //     size: {
    //       height: 350,
    //       width: 700
    //     },
    //   });
    // }
    this.dataAnalyticService.getChatBoxStatus().subscribe(value => {
      const commenFactor = 160;
      if (this.barChart) {
        const width = this.barGraphDiv.nativeElement.children.item(0) ?
          this.barGraphDiv.nativeElement.children.item(0).width.baseVal.value : 0;
        if (value && this.barChart) {
          this.barChart.resize({ width: width - commenFactor });
        } else if (this.barChart) {
          this.barChart.resize({ width: width + commenFactor });
        }
      }
      if (this.lineChart) {
        const width = this.lineGraphDiv.nativeElement.children.item(0) ?
          this.lineGraphDiv.nativeElement.children.item(0).width.baseVal.value : 0;
        if (value && this.lineChart) {
          this.lineChart.resize({ width: width - commenFactor });
        } else if (this.lineChart) {
          this.lineChart.resize({ width: width + commenFactor });
        }
      }
    });
    try {
      this.currencyService.currencyValue$.subscribe((currencyValue: any) => {
        this.currencyRate = currencyValue.crate;
        // this.level = 'factory';
        this.getTrendsData();
      });
    } catch (error) {

    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.route.queryParams.subscribe(params => {
        if (params.level && params.factory) {
          this.level = params.level;
          this.lineId = (params.LineId) ? params.LineId : null;
          this.getTrendsData();
        }
      });
    }, 0);
  }

  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  getTrendsData() {
    const daDate = this.getLocalStorageData('selectedDATimeFilter');
    const selectedHourDetail = {};
    this.currentEndWeek = '';
    this.emitDataList = {
      appliedFilterType: daDate ? daDate.appliedFilterType : '',
      dateObj: new Date(this.factorySummary.fromDate),
      selectedHr: selectedHourDetail,
      endWeekFromSelectedDate: this.currentEndWeek,
      startQuarterMonth: null
    };
    this.oneDate = this.emitDataList.dateObj;
    this.monthName = this.oneDate.toLocaleString('en-us', { month: 'short' });

    this.actualConsList = this.trendsData.actualConsumption.map(
      conseptionList => conseptionList.actualConsumptionCost * this.currencyRate);
    this.zeroBasedList = this.trendsData.actualConsumption.map(conseptionList => conseptionList.zeroBasedTarget * this.currencyRate);
    this.targetBasedList = this.trendsData.actualConsumptionWastePercentage.map(percentageList => percentageList.wastePercentage);
    this.xAxisValuesCost = this.trendsData.actualConsumption.map(percentageList => percentageList.dayOrMonth);
    this.xAxisValuesPercentage = this.trendsData.actualConsumptionWastePercentage.map(percentageList => percentageList.dayOrMonth);
    // this.trendsData.wasteTargetCost = this.trendsData.wasteTargetCost * this.currencyRate;
    const lowestCost = Math.min(...this.actualConsList);

    if (lowestCost >= 1000000000) {
      // Billion
      this.divisionNumber = 1000000000;
      this.signType = 'B';
    } else if (lowestCost >= 1000000) {
      // Million
      this.divisionNumber = 1000000;
      this.signType = 'M';
    } else if (lowestCost >= 1000) {
      // Thousand
      this.divisionNumber = 1000;
      this.signType = 'K';
    }

    this.actualConsList = ['data1'].concat(this.actualConsList);
    this.zeroBasedList = ['data2'].concat(this.zeroBasedList);
    this.targetBasedList = ['data1'].concat(this.targetBasedList);
    this.xAxisValuesCost = ['x'].concat(this.xAxisValuesCost);
    this.xAxisValuesPercentage = ['x'].concat(this.xAxisValuesPercentage);

    for (let index = 0; index < this.targetBasedList.length; index++) {
      if (index === 0) {
        this.wastePercent = ['data2'];
      } else {
        this.wastePercent.push(this.trendsData.wasteTargetPercentage);
      }
    }

    for (let indexCount = 0; indexCount < this.actualConsList.length; indexCount++) {
      if (indexCount === 0) {
        this.targetWasteCost = ['waste'];
      } else {
        this.targetWasteCost.push(this.trendsData.wasteTargetCost * this.currencyRate);
      }
    }

    this.drawLineGraph();
    this.drawBarGraph();
  }

  drawLineGraph() {
    try {
      this.lineChart = c3.generate({
        bindto: this.lineGraphDiv.nativeElement,
        data: {
          x: 'x',
          columns: [
            this.xAxisValuesPercentage,
            this.targetBasedList,
            this.wastePercent
          ],
          axes: {
            waste: 'y2'
          },
          colors: {
            data1: '#D26999',
            data2: '#00B2A9'
          },
          names: {
            data1: 'Waste %',
            data2: 'Target Waste %'
          }
        },
        point: {
          show: false
        },
        axis: {
          x: {
            label: {
              text: ((this.emitDataList &&
                (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year'))
                ? 'Month' : 'Date'),
              position: 'outer-center'
            },
            show: true
          },
          y: {
            show: true,
            label: {
              text: 'Waste %',
              position: 'outer-middle'
            },
            tick: {
              format: ((y) => y + '%'),
              outer: true,
            }
          },
          y2: {
            show: true,
            tick: {
              format: ((y) => y + '%'),
              values: [],
              outer: true,
            }
          }
        },
        tooltip: {
          format: {
            title: (x: number) => (this.emitDataList &&
              (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year')
              ? monthnames[x - 1] : (x + ' ' + this.monthName + ' ')),
            value: (x: number) => x.toFixed(2) + '%'
          }
        },
      });
    } catch (error) {

    }
  }

  drawBarGraph() {
    try {
      const thisObj = this;
      this.barChart = c3.generate({
        bindto: document.getElementById('myContainer'),
        data: {
          x: 'x',
          columns: [
            this.xAxisValuesCost,
            this.actualConsList,
            this.zeroBasedList,
            this.targetWasteCost
          ],
          types: {
            data1: 'bar',
            data2: 'bar',
            waste: 'line'
          },
          colors: {
            data1: '#00A4D9',
            data2: '#081894',
            waste: '#D26999'
          },
          names: {
            data1: 'Actual Consumption',
            data2: 'Zero Based Waste Target',
            waste: 'Target Waste Cost'
          }
        },
        point: {
          show: false
        },
        legend: {
          show: true,
          inset: {
            anchor: 'bottom-left',
            x: 20,
            y: 10,
            step: 2
          }
        },
        axis: {
          x: {
            label: {
              text: ((this.emitDataList &&
                (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year'))
                ? 'Month' : 'Date'),
              position: 'outer-center'
            }
          },
          y: {
            label: {
              text: 'Cost',
              position: 'outer-middle'
            },
            tick: {
              format: ((x) => x / thisObj.divisionNumber + thisObj.signType)
            },
            show: true,
          },
          y2: {
            tick: {
              values: []
            },
            show: true,
          }
        },
        tooltip: {
          format: {
            title: (x: number) => (this.emitDataList &&
              (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year')
              ? monthnames[x - 1] : (x + ' ' + this.monthName + ' ')),
            value: (x: number) => (x / thisObj.divisionNumber).toFixed(2) + thisObj.signType
          }
        },
        bar: {
          width: 4
        }
      });
    } catch (error) {

    }
  }

  onChangeDate(start, end) {
    this.factorySummary.fromDate = start;
    this.factorySummary.toDate = end;
    this.getTrendsData();
  }

  toggleType(type: string) {
    try {
      if (type !== this.selectedChartType) {
        this.selectedChartType = type;
        this.drawLineGraph();
        this.drawBarGraph();
      }
    } catch (error) {

    }
  }

  openDialog() {

    const dialogRef = this.dialog.open(DaChartPopupComponent, {
      width: '840px',
      height: '500px',
      data: {
        type: this.selectedChartType,
        actualConsList: this.actualConsList,
        zeroBasedList: this.zeroBasedList,
        targetBasedList: this.targetBasedList,
        wastePercent: this.trendsData.wasteTargetPercentage,
        lineWastePercentage: this.wastePercent,
        xAxisValuesCost: this.xAxisValuesCost,
        xAxisValuesPercentage: this.xAxisValuesPercentage,
        divisionNumber: this.divisionNumber,
        signType: this.signType,
        wasteTargetCost: this.trendsData.wasteTargetCost,
        targetWasteCost: this.targetWasteCost,
        level: this.level
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}
